import React from 'react';

interface Props {
  isOpen: boolean;
}

export const SectionArrow = ({ isOpen, ...props }: Props) => (
  <svg
    width="8"
    height="4"
    css={{
      transform: `rotate(${isOpen ? 0 : -180}deg)`,
      transition: 'all 0.3s ease',
    }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.354.354l2.792 2.792A.5.5 0 016.793 4H1.207a.5.5 0 01-.353-.854L3.646.354a.5.5 0 01.708 0z"
      fill="#D4D8E4"
    />
  </svg>
);

export default SectionArrow;
